import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { fetchPost } from '../../../store/fetch';
import { EditPanelCell, EditPanelInput, EditPanelRow, EditPanelSection, EditPanelSelect, EditPanelTextArea } from '../../elements';
import { ComponentSetStatePromised } from '../../utils/ComponentSetStatePromised';
import { DisplayMessage } from '../../utils/displayMessage';

export interface IMailShareLinkProps extends ITranslateProps {
    surveyId: string;
}

export interface IMailShareLinkState {
    message?: string;
    submitted: boolean;
    failed: boolean;
    userName?: string;
    emailAddress?: string;
    availability: number;
    loading: boolean;
    popupVisible: boolean;
}

class MailShareLinkComponent extends ComponentSetStatePromised<IMailShareLinkProps, IMailShareLinkState> {
    constructor(props: IMailShareLinkProps) {
        super(props);

        this.state = {
            failed: false,
            submitted: false,
            loading: false,
            popupVisible: false,
            availability: 14,
        };
    }

    public getValidatorData() {
        return {
            availability: this.state.availability,
            emailAddress: this.state.emailAddress,
            message: this.state.message,
        };
    }

    public override render() {
        return (
            <>
                <a href="#" onClick={(e) => this.handleOpenPopopClicked(e)} className="btn btn-sm btn-default fw600 ml10" id="open">
                    <span className="fa fa-envelope mr5"></span>
                    {this.props.t('survey.mailShareLink')}
                </a>
                {this.state.popupVisible && (
                    <div id="popup_element" className="admin-form theme-primary mw600" style={{ maxHeight: '80%' }}>
                        <form method="post" action="/" onSubmit={async (e) => this.saveClicked(e)}>
                            <div className="panel">
                                <div className="panel-header">
                                    <div className="p25">
                                        <h2 className="fw200">{this.props.t('survey.mailShareLink')}</h2>
                                    </div>
                                </div>
                                {this.state.failed && (
                                    <DisplayMessage
                                        message={this.props.t('login.failedSendShareLink')}
                                        messageType="error"
                                        onClose={() => this.setState({ failed: false })}
                                    />
                                )}

                                <div className="panel-body bg-light">
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={8}>
                                            <EditPanelInput
                                                name="emailAddress"
                                                topLabel={this.props.t('survey.mailTo')}
                                                value={this.state.emailAddress}
                                                icon="fa fa-envelope-o"
                                                handleChange={this.handleChange.bind(this)}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={8}>
                                            <EditPanelSelect
                                                name="availability"
                                                topLabel={this.props.t('survey.availability')}
                                                value={this.state.availability}
                                                handleChange={this.handleChange.bind(this)}
                                                options={[
                                                    { value: '2', text: this.props.t('survey.availability2') },
                                                    { value: '14', text: this.props.t('survey.availability14') },
                                                    { value: '28', text: this.props.t('survey.availability28') },
                                                    { value: '60', text: this.props.t('survey.availability60') },
                                                    { value: '183', text: this.props.t('survey.availability183') },
                                                    { value: '36500', text: this.props.t('survey.availability0') },
                                                ]}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>

                                    {/* Message */}
                                    <div className="section-divider mt40 mb40">
                                        <span>{this.props.t('survey.message')}</span>
                                    </div>

                                    <EditPanelSection>
                                        <EditPanelTextArea
                                            name="message"
                                            placeholder={this.props.t('survey.message')}
                                            value={this.state.message}
                                            icon="fa fa-file-text-o"
                                            handleChange={this.handleChange.bind(this)}
                                        />
                                    </EditPanelSection>

                                    <div className=" text-right mt10">
                                        <button type="button" onClick={this.handleClosePopopClicked.bind(this)} className="btn btn-sm fw600 ml10">
                                            {this.props.t('common.close')}
                                        </button>
                                        <button
                                            className="btn btn-primary btn-sm fw600 ml10"
                                            disabled={this.state.loading}
                                            onClick={async (e: any) => this.saveClicked(e)}
                                        >
                                            {this.props.t('common.submit')}{' '}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                )}
                {this.state.popupVisible && (
                    <div id="background_popup" style={{ opacity: 0.6, display: 'block' }} onClick={(e) => this.handleClosePopopClicked(e)}></div>
                )}
            </>
        );
    }

    private handleClosePopopClicked(e: any) {
        e.preventDefault();
        this.setState({ popupVisible: false });
    }

    private handleOpenPopopClicked(e: any) {
        e.preventDefault();
        this.setState({ popupVisible: true });
    }

    private handleChange(value: any, stateKey: string) {
        const newState = {} as any;
        newState[stateKey] = value;
        this.setState(newState);
    }

    private async saveClicked(e: any) {
        e.preventDefault();
        await this.setStatePromised({ loading: true });
        const data = this.getValidatorData() as any;
        const url = `/api/surveys/${this.props.surveyId}/sharelink`;
        const result = await fetchPost(url, {}, data, ['FAILED_SENDING_MAIL']);
        if (result.errorCode === 'FAILED_SENDING_MAIL') {
            await this.setStatePromised({ submitted: false, failed: true, loading: false });
        } else {
            await this.setStatePromised({ submitted: true, failed: false, loading: false, popupVisible: false, emailAddress: '', message: '' });
        }
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const MailShareLink = translate()(MailShareLinkComponent);
export { MailShareLink };
